/**
 * Retrieves the outer resource to which currentWindow belongs or null if the shell is not loaded.
 * @param currentWindow
 */
export default function getRootResourceWindow(currentWindow) {
    let win = currentWindow;
    while (win.parent !== win) {
        try {
            if (typeof win.parent.shell !== 'undefined' || typeof win.parent.dapi !== 'undefined') {
                return win;
            }
        }
        catch (error) {
            // Chrome and FF throw an error while accessing 'shell' property if parent window has a different origin cf. https://jira.d-velop.de/browse/SA-86
            break;
        }
        win = win.parent;
    }
    return null;
}
